import { Injectable } from "@angular/core";
import { ApiService } from "../../api/api.service";
import { HttpParams } from "@angular/common/http";
import {
  INotificationListReq,
  INotificationApiData,
  ISendNotificationReq,
  IAdminNotificationListItem,
  ISendNotificationRes,
  INotificationActionRes,
} from "../../../_models/notification.model";
import { Observable } from "rxjs";
import { IAppResponse } from "../../../_interceptors/network-error.model";

@Injectable({
  providedIn: "root",
  })
export class NotificationService {
  constructor(private apiService: ApiService) {}

  getAll(req: INotificationListReq): Observable<IAppResponse<INotificationApiData>> {
    let params = new HttpParams({
      fromObject: {
        page: String(req.page),
        limit: String(req.limit),
        ...(req.search && { search: req.search }),
        ...(req.audience && { audience: req.audience }),
        ...(req.deliveryType && { deliveryType: req.deliveryType }),
        ...(req.status && { status: req.status }),
        ...(req.includeDeleted !== undefined && { includeDeleted: String(req.includeDeleted) }),
      },
    });

    return this.apiService.get<INotificationApiData>({
      Url: "dating/admin/notifications",
      Params: params,
    });
  }

  getById(id: string): Observable<IAppResponse<IAdminNotificationListItem>> {
    return this.apiService.get<IAdminNotificationListItem>({
      Url: `dating/admin/notifications/${id}`,
    });
  }

  send(body: ISendNotificationReq): Observable<IAppResponse<ISendNotificationRes>> {
    return this.apiService.post<ISendNotificationReq, ISendNotificationRes>({
      Url: "dating/admin/notifications/send",
      Body: body,
    });
  }

  resend(id: string): Observable<IAppResponse<INotificationActionRes>> {
    return this.apiService.post<{}, INotificationActionRes>({
      Url: `dating/admin/notifications/${id}/resend`,
      Body: {},
    });
  }

  delete(id: string): Observable<IAppResponse<INotificationActionRes>> {
    return this.apiService.delete<{}, INotificationActionRes>({
      Url: `dating/admin/notifications/${id}`,
      Body: {},
    });
  }

  bulkDelete(ids: string[]): Observable<IAppResponse<INotificationActionRes>> {
    return this.apiService.post<{ notificationIds: string[] }, INotificationActionRes>({
      Url: "dating/admin/notifications/bulk-delete",
      Body: { notificationIds: ids },
    });
  }
}
